
import Api from './api'

export default {
    get: function (email) {

        return Api.get(`/emails/${ email }/type`)
            .then(data => {
                return data.provider === 'microsoft' ? {provider: 'outlook'} : data
            })

    }
}
